import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tud-website/tud-website/src/views/Search/index.tsx");
